/**
 * Ending a session.
 *
 * Two places offer it — the workspace menu and the profile menu — and both
 * have to do the same three things, so it lives here rather than in whichever
 * component happened to need it first.
 */
import api, { hasSession } from './api.js';
import { clearOfflineChoice, clearLocal } from './storage.js';

/**
 * Sign out everywhere: revoke the refresh token on the server, drop the local
 * tokens, and clear the offline choice — without that last step the gate in
 * <App> lets the workspace straight back in without asking for a password.
 *
 * The server call is allowed to fail. Offline, or with a token the server has
 * already forgotten, the local session still has to go.
 */
export async function signOut() {
  const online = hasSession();
  try {
    await api.auth.logout();
  } catch {
    /* Local sign-out stands either way. */
  }
  api.clearTokens();
  clearOfflineChoice();
  /*
   * The browser keeps its own copy of the client book, the CRM and the
   * settings as it works. Signed in to a server, that copy is never read back
   * — the server is the record — so after sign-out it is only a leftover: the
   * whole client list, readable by the next person at this machine without a
   * password. Offline the copy IS the workspace, so there it stays.
   */
  if (online) clearLocal();
  window.dispatchEvent(new CustomEvent('rh:signed-out'));
}

export default signOut;
